import React from 'react'

const CarrierName = ({ carrierName, shipmentObjUpdateEvent, showOrHide }) => {

    if (showOrHide === "show" || showOrHide === "hilight") {
        return (

            <div className={`d-inline-block ${showOrHide}`}>
                {" "}
                Carrier Name:
                <br />
                <input
                    className="form-control form-control-sm"
                    type="text"
                    name="carrierName"
                    value={
                        carrierName === null
                            ? ""
                            : carrierName
                    }
                    onChange={(event) => shipmentObjUpdateEvent(event)}
                    placeholder="If Different From Existing Carrier Name"
                />
            </div>

        )
    } else {
        return null
    }
}

export default CarrierName
